import { call, put, takeEvery } from "redux-saga/effects";
import { config } from "../../../config/global";
import { flightScheduleRequest, flightScheduleSuccess, flightScheduleFailure } from "../slice/flightScheduleSlice";
import api from "../../../config/api";
const FLIGHT_SCHEDULE_API = config.FLIGHT_SCHEDULE_URL;
const flightScheduleData = async payload => {
  const data = {
    headers: {
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "accessToken"
    },
    loader: true
  };
  const response = await api.post(FLIGHT_SCHEDULE_API, payload, data);
  return response;
};
function* fetchFlightSchedule(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(flightScheduleData, payload);
    yield put(flightScheduleSuccess(response?.data));
  } catch (error) {
    yield put(flightScheduleFailure(error?.response?.data));
  }
}
export function* watchFlightSchedule() {
  yield takeEvery(flightScheduleRequest.type, fetchFlightSchedule);
}